import {join, ifElse, isEmpty, either, isNil, identity, always, toString} from 'ramda';

const formatter = ifElse(either(isEmpty, isNil), () => '-');

export const formatAddOns = formatter(join(', '));

export const formatBoolean = formatter(ifElse(identity, always('Yes'), always('No')));

export const formatInt = formatter(toString);
